<section class="block-time-record-modal" aria-labelledby="btr_modal_title">
    <header class="block-time-record-modal__header">
        <div class="block-time-record-modal__heading">
            <ds-text
                id="btr_modal_title"
                role="heading"
                aria-level="2"
                size="xl"
                weight="semibold"
                [color]="titleColor"
                [text]="title"
            ></ds-text>
            <ds-text size="sm" weight="regular" theme="secondary" [text]="subtitle"></ds-text>
        </div>
        <ds-icon-button
            class="block-time-record-modal__close"
            icon="close"
            theme="secondary-gray"
            size="lg"
            (buttonClick)="close()"
        ></ds-icon-button>
    </header>

    <div class="block-time-record-modal__body">
        <section class="block-time-record-modal__card" aria-labelledby="btr_details_title">
            <app-btr-section-title headingId="btr_details_title" text="Service request details" [step]="1"></app-btr-section-title>
            <app-btr-service-request-details
                [facts]="facts"
                [isAddMode]="isAddMode"
                [group]="detailsGroup"
                [tripOptions]="tripOptions"
                [customerOptions]="customerOptions"
                [airVendorOptions]="airVendorOptions"
                [tailOptions]="tailOptions"
                [validationRun]="validationRun"
                [isLoadingLists]="isLoadingLists"
                [isLoadingTails]="isLoadingTails"
            ></app-btr-service-request-details>
        </section>

        <ng-container *ngIf="hoursCards">
            <div class="block-time-record-modal__hours">
                <section class="block-time-record-modal__card" aria-labelledby="btr_estimated_title">
                    <app-btr-hours-card
                        cardId="btr_estimated"
                        [step]="2"
                        [card]="hoursCards.estimated"
                        [hoursGroup]="hoursGroup"
                        [validationRun]="validationRun"
                    ></app-btr-hours-card>
                </section>

                <section class="block-time-record-modal__card" aria-labelledby="btr_actual_title">
                    <app-btr-hours-card
                        cardId="btr_actual"
                        [step]="3"
                        [card]="hoursCards.actual"
                        [isActual]="true"
                        [isCancellationVisible]="isCancellationVisible"
                        [cancellationHours]="cancellationHours"
                        [hoursGroup]="hoursGroup"
                        [validationRun]="validationRun"
                        [airportOptions]="airportOptions"
                    >
                        <app-btr-ib-repo-status
                            ibRepoStatus
                            [state]="ibRepoState"
                            [canVerify]="canVerify"
                            [isPanelOpen]="isVerifyPanelOpen"
                            (openPanel)="openVerifyPanel()"
                        ></app-btr-ib-repo-status>

                        <ng-container ngProjectAs="[ibRepoPanel]" *ngIf="isVerifyPanelOpen">
                            <app-btr-ib-repo-verification-panel
                                @expand
                                [blockTimeRecordId]="draft.blockTimeReportID"
                                [state]="ibRepoState"
                                [panelId]="ibRepoPanelId"
                                (verified)="onIbRepoVerified($event)"
                                (cancelled)="closeVerifyPanel()"
                                (pendingChange)="onVerifyPendingChange($event)"
                            ></app-btr-ib-repo-verification-panel>
                        </ng-container>

                        <ng-container ngProjectAs="[ibRepoPanel]" *ngIf="isIbRepoVerified && !isVerifyPanelOpen">
                            <p class="block-time-record-modal__saved-note" role="status" @expand>{{ verificationSavedNote }}</p>
                        </ng-container>
                    </app-btr-hours-card>
                </section>
            </div>
        </ng-container>

        <section class="block-time-record-modal__card" aria-labelledby="btr_billing_title">
            <app-btr-section-title headingId="btr_billing_title" text="Billing info" [step]="4"></app-btr-section-title>
            <app-btr-billing-info
                [group]="form.controls.billing"
                [isAddMode]="isAddMode"
                [isContracted]="isContracted"
                [storedRate]="draft.rate"
                [storedFlightMargin]="draft.flightMargin"
                [monthYearOptions]="monthYearOptions"
                [actualTotal]="actualTotal"
                [estimatedTotal]="estimatedTotal"
                [validationRun]="validationRun"
            ></app-btr-billing-info>
        </section>
    </div>

    <footer class="block-time-record-modal__footer">
        <p class="block-time-record-modal__validation" role="alert">{{ validationMessage }}</p>
        <div class="block-time-record-modal__actions">
            <ds-button label="Cancel" theme="secondary-gray" size="lg" (buttonClick)="close()"></ds-button>
            <ds-button
                size="lg"
                [label]="saveLabel"
                [isLoading]="isSaving"
                [isDisabled]="isVerifyPending"
                (buttonClick)="save()"
            ></ds-button>
        </div>
    </footer>
</section>
